import './TrophyCasePage.css'
import { useTrophyCase } from '../../hooks/useTrophyCase'
import AwardsSection from './AwardsSection'
import PageHeader from '../common/layout/PageHeader'

export default function TrophyCasePage() {
  const { trophies, bagTags, loading, error } = useTrophyCase()

  if (loading) {
    return (
      <div className="trophy-case-container">
        <PageHeader title="Trophy Case" showBack={true} />
        <div className="trophy-case-loading">Loading your awards...</div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="trophy-case-container">
        <PageHeader title="Trophy Case" showBack={true} />
        <div className="trophy-case-error">Error loading awards: {error}</div>
      </div>
    )
  }

  const hasAnyAwards = trophies.length > 0 || bagTags.length > 0

  return (
    <div className="trophy-case-container">
      <PageHeader title="Trophy Case" showBack={true} />

      <main className="trophy-case-content">
        {!hasAnyAwards ? (
          <div className="trophy-case-empty-state">
            <div className="empty-state-icon" aria-hidden="true">
              🏆
            </div>
            <h2>Your Trophy Case is Empty</h2>
            <p>
              Keep competing in leagues and divisions to earn awards and build
              your trophy collection!
            </p>
          </div>
        ) : (
          <>
            <AwardsSection
              title="Trophies"
              awards={trophies}
              emptyMessage="No trophies yet. Win a league championship to earn your first trophy!"
            />

            <AwardsSection
              title="Bag Tags"
              awards={bagTags}
              emptyMessage="No bag tags yet. Win a division to earn your first bag tag!"
            />
          </>
        )}
      </main>
    </div>
  )
}
